<template>
  <!-- navigation START -->
  <div id="nav">
    <div class="main-navigation">
      <!-- logo START -->
      <div class="logo logo-centered">
        <router-link :to="'/'">
          <img
            width="320"
            height=""
            src="@/assets/images/logo-eccovia-full.png"
            v-if="$route.name !== 'screensaver'"
          />
          <img
            width="320"
            height=""
            src="@/assets/images/logo-eccovia-full-white.png"
            v-else
          />
        </router-link>
      </div>
      <!-- logo END -->
    </div>
  </div>
  <!-- navigation END -->
</template>

<script>
export default {
  name: 'app-navigation',
  data() {
    return {
    };
  },
};
</script>
